import React from 'react'
import { Account } from './Account'

export default {
  title: 'Pages/Account',
  component: Account,
}

export const AccountPage = () => <Account />
